export const GOALS = [
  { id: 1, employee: "Priya Sharma",    goal: "Launch microservices migration",     progress: 72, due: "Mar 31", status: "On Track" },
  { id: 2, employee: "Marcus Johnson",  goal: "Ship Q1 product roadmap",            progress: 55, due: "Mar 31", status: "At Risk"  },
  { id: 3, employee: "Carlos Rivera",   goal: "Build real-time analytics dashboard",progress: 90, due: "Mar 15", status: "On Track" },
  { id: 4, employee: "Sofia Martínez",  goal: "Increase brand reach by 40%",        progress: 38, due: "Jun 30", status: "On Track" },
];

export const PERFORMANCE_REVIEWS = [
  { name: "Priya Sharma",   period: "Q4 2025", rating: "Exceeds Expectations", score: 92, reviewer: "Arjun Kumar",      status: "Completed"   },
  { name: "Marcus Johnson", period: "Q4 2025", rating: "Meets Expectations",   score: 78, reviewer: "Sarah Lee",         status: "Completed"   },
  { name: "Carlos Rivera",  period: "Q4 2025", rating: "Exceeds Expectations", score: 88, reviewer: "Fatima Al-Hassan",  status: "In Progress" },
  { name: "Liam O'Brien",   period: "Q4 2025", rating: "Needs Improvement",    score: 61, reviewer: "Arjun Kumar",      status: "Pending"     },
];
